import {useState} from 'react';

export const useLocale = () => {
	const [lang, setLang] = useState(localStorage.getItem('locale') ?? 'ru')

	const handleSetLang = (lang) => {
		localStorage.setItem('locale', lang);
		setLang(lang);
	}

	return {
		lang,
		handleSetLang
	}
};
